import { render } from "./comprehensiveAnswer.vue?vue&type=template&id=3b33e6ca&scoped=true"
import script from "./comprehensiveAnswer.vue?vue&type=script&lang=js"
export * from "./comprehensiveAnswer.vue?vue&type=script&lang=js"

import "./comprehensiveAnswer.vue?vue&type=style&index=0&id=3b33e6ca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b33e6ca"]])

export default __exports__